<template>
  <div class="space-property content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="top__filter mb-2">
          <ul class="top__filter__ul">
            <li>
              <router-link class="opacity--50 text-white" to="/dashboard">
                <i class="fas fa-chevron-left"></i> View all {{ $t("PROPES") }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-6">
                <div class="content__box">
                  <!-- Property Name and ratings section -->
                  <div class="content__box__header">
                    <!-- Property edit section -->
                    <div class="top__filter">
                      <ul class="top__filter__ul">
                        <li class="cursor-default">{{ $t("PROPERTY") }}</li>
                      </ul>
                      <ul class="top__filter__ul">
                        <li
                          v-if="(hasAccess('gate_access_write') || hasAccess('validation_access_write')) && controlGates && laneDevices.length"
                          class="opacity--1 property__edit__dropdown"
                        >
                          <a
                            href="javascript:void(0)"
                            class="opacity--50 text-white"
                            @click="openModal('live-footage')"
                          >Control Gates</a>
                        </li>
                        <li
                          v-if="hasAccess('all_property_access_write') || hasAccess('permit_access_read')"
                          class="dropdown opacity--1 property__edit__dropdown"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-toggle opacity--50 text-white"
                            data-toggle="dropdown"
                            data-display="static"
                            >Edit</a
                          >

                          <ul
                            class="
                              dropdown-menu
                              dropdown-menu-right
                              dropdown-menu-lg-left
                            "
                          >
                            <li
                              v-if="hasAccess('all_property_access_write')"
                              class="dropdown-item"
                              @click="openModal('property-details-edit')"
                            >
                              <span
                                v-tooltip.top-center="'Details is incomplete!'"
                                v-if="
                                  Object.keys(space_details).length > 0 &&
                                  (space_details.details.status != 1 ||
                                    space_details.location.status != 1)
                                "
                              >
                                <i
                                  class="
                                    fas
                                    fa-exclamation-triangle
                                    mr-2
                                    txt--red
                                  "
                                ></i>
                              </span>
                              {{ $t("Details") }}
                            </li>
                            <li
                              v-if="hasAccess('all_property_access_write')"
                              class="dropdown-item"
                              @click="openModal('property-edit-availability')"
                            >
                              <span
                                v-tooltip.top-center="
                                  'Availability is incomplete!'
                                "
                                v-if="
                                  Object.keys(space_details).length > 0 &&
                                  space_details.availability.status != 1
                                "
                              >
                                <i
                                  class="
                                    fas
                                    fa-exclamation-triangle
                                    mr-2
                                    txt--red
                                  "
                                ></i>
                              </span>
                              {{ $t("Availability") }}
                            </li>
                            <li
                              v-if="hasAccess('all_property_access_write')"
                              class="dropdown-item"
                              @click="openModal('property-pricing')"
                            >
                              <span
                                v-tooltip.top-center="'Price is incomplete!'"
                                v-if="
                                  Object.keys(space_details).length > 0 &&
                                  space_details.price.status != 1
                                "
                              >
                                <i
                                  class="
                                    fas
                                    fa-exclamation-triangle
                                    mr-2
                                    txt--red
                                  "
                                ></i>
                              </span>
                              {{ $t("Pricing") }}
                            </li>
                            <li
                              v-if="hasAccess('all_property_access_write')"
                              class="dropdown-item"
                              @click="openModal('property-image-upload')"
                            >
                              <span
                                v-tooltip.top-center="'Images are incomplete!'"
                                v-if="
                                  Object.keys(space_details).length > 0 &&
                                  space_details.photo.status != 1
                                "
                              >
                                <i
                                  class="
                                    fas
                                    fa-exclamation-triangle
                                    mr-2
                                    txt--red
                                  "
                                ></i>
                              </span>
                              {{ $t("Photos") }}
                            </li>
                            <li
                              class="dropdown-item d-none"
                              @click="openModal('monthly-subscription-form')"
                            >
                              {{ $t("Subscription_form") }}
                            </li>
                            <li
                              v-if="hasAccess('permit_access_read')"
                              class="dropdown-item"
                              @click="openModal('permit-customer')"
                            >
                              {{ $t("Monthly_subscribers") }}
                            </li>
                            <!-- <li
                              class="dropdown-item"
                              v-if="validation_access == true"
                              @click="openModal('validation-modal')"
                            >
                              Validations
                            </li> -->
                              <!-- v-if="space_details.space_status == 4" -->
                            <li
                              class="dropdown-item"
                              v-if="hasAccess('all_property_access_write') && space_details.space_status == 4"
                              @click="changePropertyStatus"
                            >
                              {{
                                space_details.active
                                  ? $t("MK_OFFLINE")
                                  : $t("MK_ONLINE")
                              }}
                            </li>
                          </ul>
                        </li>
                        <li class="dropdown opacity--1 d-none">
                          <a
                            href="javascript:void(0)"
                            class="opacity--50 text-white"
                            @click="deleteProperty"
                            >Delete</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="monthActivity">
                      <p class="txt--fslg pt-2">{{ property_name }}</p>
                    </div>
                    
                    <div
                      v-if="propertyDetailsLoader"
                      class="
                        d-flex
                        justify-content-center
                        reports__details--body
                        m-customer--min-height
                      "
                    >
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <div v-if="!propertyDetailsLoader" class="d-flex align-items-center py-2 flex-wrap">
                      <div class="d-flex align-items-center mb-2 mr-2">
                        <div
                          @click="openModal('review-modal')"
                          class="cursor-pointer"
                        >
                          <stars-rating :config="usrconfig"></stars-rating>
                        </div>
                        <p
                          class="txt--ss opacity--50 pl-3 cursor-pointer"
                          @click="openModal('review-modal')"
                        >
                          {{ space_details.review_count }}

                          {{
                            space_details.review_count > 1
                              ? "Reviews"
                              : "Review"
                          }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center mb-2">
                        <span
                          class="badge badge-pill badge-light"
                          v-if="
                            space_details.space_status != '' &&
                            space_details.space_status != 3
                          "
                        >
                          {{
                            space_details.space_status == 1
                              ? "Incomplete"
                              : space_details.space_status == 2
                              ? "In review"
                              : space_details.space_status == 4
                              ? "Verified"
                              : ""
                          }}
                        </span>
                        <span
                          :class="[
                            'badge badge-pill ml-2',
                            space_details.active &&
                            space_details.space_status == 4
                              ? 'badge-success'
                              : 'badge-danger',
                          ]"
                        >
                          {{
                            space_details.active &&
                            space_details.space_status == 4
                              ? "Online"
                              : "Offline"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Property activity section -->
                <div class="content__box content__box--activity mt-4">
                  <div class="content__box__header pb-0">
                    <div class="top__filter">
                      <ul class="top__filter__ul">
                        <li class="cursor-default">{{ $t("ACTIVITY") }}</li>
                      </ul>
                    </div>
                    <div class="monthActivity">
                      <div class="form-row">
                        <div class="col-auto mb-2">
                          <v-select
                            class="style-chooser monthly-filter-select selectTransparent "
                            label="name"
                            :searchable="false"
                            :options="month_list"
                            :clearable="false"
                            v-model="currentMonthDate"
                            :reduce="(name) => name.value"
                            @input="changeActivityMonth()"
                            placeholder="Select month"
                          ></v-select>
                        </div>
                        <div class="col-auto mb-2">
                          <v-select
                            class="style-chooser monthly-filter-select selectTransparent"
                            label="name"
                            :searchable="false"
                            v-model="currentYear"
                            :options="years"
                            :clearable="false"
                            :reduce="(name) => name.value"
                            @input="changeActivityYear()"
                            placeholder="Select year"
                          >
                          </v-select>
                        </div>
                      </div>

                      <VueSlickCarousel v-bind="carouselSettings">
                        <div v-for="(m, i) in currentMonth" :key="i">
                          <div
                            class="monthDate"
                            :class="{
                              active:
                                (m.full_date === currentDate &&
                                  activedate === null) ||
                                activedate === i,
                              opacity6: m.full_date > currentDate,
                            }"
                            @click="focusDate(i, $event)"
                          >
                            <p class="monthDay mb-1">{{ m.day }}</p>
                            <p class="monthNum mb-1">{{ m.date }}</p>
                            <div class="activeDay"></div>
                          </div>
                        </div>
                        <template #prevArrow="prevArrowOption">
                          <button
                            type="button"
                            data-role="none"
                            class="custom-arrow custom-arrow-left"
                            :class="{
                              disabledMonth: prevArrowOption.currentSlide == 0,
                            }"
                          >
                            <i class="fas fa-angle-left"></i>
                          </button>
                        </template>
                        <template #nextArrow="nextArrowOption">
                          <button
                            type="button"
                            class="custom-arrow custom-arrow-right"
                            :class="{
                              disabledMonth:
                                nextArrowOption.currentSlide == today - 1,
                            }"
                          >
                            <i class="fas fa-angle-right"></i>
                          </button>
                        </template>
                      </VueSlickCarousel>
                    </div>
                  </div>
                  <div class="content__divider"></div>

                  <div
                    class="
                      content__box__body
                      box__height box__height box__height--activity-property
                      py-0
                    "
                  >
                    <div
                      v-for="(activity, index) in activity_list"
                      :key="index"
                    >
                      <div class="activity__new-time">
                        <p class="txt--ss opacity--50 text-truncate">
                          {{ activity.created_at_time }}
                        </p>
                      </div>

                      <div class="activity__new has-activity">
                        <div class="activity__indicator">
                          <div class="activity__blue"></div>
                        </div>
                        <div class="activity__txt">
                          <div class="activity__image">
                            <img
                              src="@/assets/images/car.png"
                              class="w-100"
                              alt
                            />
                          </div>
                          <div
                            :class="[
                              'activity__msg txt--semi-bold',
                              activity.target == 'bookings'
                                ? 'cursor-pointer'
                                : '',
                            ]"
                            @click="openActivitySession(activity)"
                          >
                            <p class="txt--ss">{{ activity.message }}</p>
                          </div>
                        </div>
                        <div class="activity__address mt-2 mt-sm-0">
                          <p class="txt--xs opacity--50 text-truncate">
                            {{
                              activity.property_name != ""
                                ? activity.property_name
                                : activity.address_short
                            }}
                          </p>
                          <p class="txt--xs opacity--50 text-truncate pt-2" v-if="activity.booking_type == 'Monthly Customer'">
                            Permit Customer
                          </p>
                          <p class="txt--xs opacity--50 text-truncate pt-2" v-else>
                            {{activity.booking_type != "" ? activity.booking_type : ""}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <infinite-loading
                      @infinite="getActivities"
                      :distance="10"
                      :identifier="activityPagination.infiniteId"
                    >
                      <div slot="spinner">
                        <div class="d-flex justify-content-center mt-4">
                          <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                      <div slot="no-more"></div>
                      <div slot="no-results">No data found</div>
                    </infinite-loading>
                  </div>
                </div>
              </div>
              <!-- Gate Image and session section -->
              <div class="col-lg-6 mt-4 mt-lg-0">
                <!-- Poperty Gate Image -->
                <!-- v-if="gate_images.length" -->
                <div class="content__box mb-4 d-none">
                  <div class="p-4">
                    <div class="top__filter pb-1">
                      <ul class="top__filter__ul">
                        <li class="opacity-5">Gates</li>
                      </ul>
                      <ul class="top__filter__ul">
                        <li
                          class="opacity-5"
                          @click="openModal('live-footage')"
                        >
                          View
                        </li>
                      </ul>
                    </div>
                    <div>
                      <div class="form-row">
                        <div
                          class="col-6 mb-3 mb-sm-0 col-sm-3"
                          v-for="gate_image in gate_images"
                          :key="gate_image.booking_id"
                        >
                          <img
                            :src="gate_image.entry_image_name"
                            alt
                            style="width: 120px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Property Session -->
                <div
                  class="content__box content__box--activity"
                  style="height: 100%"
                >
                  <div class="content__box__header pb-0">
                    <div class="top__filter flex-nowrap align-items-center">
                      <ul class="top__filter__ul">
                        <li>{{ $t("SESSION") }}</li>
                      </ul>
                      <ul class="top__filter__ul search_form_control">
                        <li>
                          <input
                            class="form-control form-control-sm"
                            type="text"
                            placeholder="Search license plate OR VIN"
                            aria-label="Search"
                            v-model="session_search"
                          />
                        </li>
                      </ul>
                      <ul class="top__filter__ul position-relative">
                        <li @click.stop="sessionsFilter = true">
                          {{ $t("Filter") }}
                        </li>

                        <div
                          v-click-outside="closeDropdown"
                          class="sessionsFilter"
                          v-if="sessionsFilter"
                        >
                          <div class="d-flex">
                            <div class="sessionsFilter__left">
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_type == 1 ? 'active' : '',
                                ]"
                                @click="sessionFilter(1)"
                              >
                                Active
                              </p>
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_type == 2 ? 'active' : '',
                                ]"
                                @click="sessionFilter(2)"
                              >
                                Past
                              </p>
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_type == 0 ? 'active' : '',
                                ]"
                                @click="sessionFilter(0)"
                              >
                                All
                              </p>
                            </div>
                            <div class="divider"></div>
                            <div class="sessionsFilter__right">
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_filter == 0 ? 'active' : '',
                                ]"
                                @click="sessionCustomerFilter(0)"
                              >
                                All
                              </p>
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_filter == 1 ? 'active' : '',
                                ]"
                                @click="sessionCustomerFilter(1)"
                              >
                                {{ $t("TC") }}
                              </p>
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_filter == 2 ? 'active' : '',
                                ]"
                                @click="sessionCustomerFilter(2)"
                              >
                                {{ $t("AC") }}
                              </p>
                              <p
                                :class="[
                                  'sessionsFilter__text mb-3',
                                  session_filter == 3 ? 'active' : '',
                                ]"
                                @click="sessionCustomerFilter(3)"
                              >
                                {{ $t("MC") }}
                              </p>
                            </div>
                          </div>

                          <div class="sessionsFilter__date">
                            <p class="txt--ss txt--primary">
                              Filter by date<span
                                class="
                                  txt--ss txt-white
                                  cursor-pointer
                                  float-right
                                "
                                v-if="start_date != '' || end_date != ''"
                                @click="clearDates"
                                >Clear</span
                              >
                            </p>

                            <div class="sessionsFilter__date__fields">
                              <div class="sessionsFilter__date__form mb-2">
                                <label
                                  class="sessionsFilter__text 2"
                                  for="start_date"
                                  >Start Date</label
                                >
                                <datetime
                                  title="Start Date"
                                  input-id="start_date"
                                  class="dateTime__picker"
                                  :format="{ month: 'short', day: 'numeric' }"
                                  :input-class="[
                                    'hidden_input',
                                    'session-filter-date',
                                  ]"
                                  :min-datetime="minDatetime"
                                  :max-datetime="maxDatetime"
                                  value-zone="local"
                                  v-model="start_date"
                                ></datetime>
                              </div>
                              <div class="sessionsFilter__date__to mb-2">
                                <label
                                  for="end_date"
                                  class="sessionsFilter__text 2"
                                  >End Date</label
                                >
                                <datetime
                                  title="End Date"
                                  input-id="end_date"
                                  class="dateTime__picker"
                                  :format="{ month: 'short', day: 'numeric' }"
                                  :input-class="[
                                    'hidden_input',
                                    'session-filter-date',
                                  ]"
                                  :min-datetime="minDatetime"
                                  :max-datetime="maxDatetime"
                                  value-zone="local"
                                  v-model="end_date"
                                ></datetime>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>

                  <div class="content__divider"></div>
                  <div
                    class="
                      content__box__body
                      box__height box__height--session-property
                    "
                    id="session_div"
                  >
                    <div class="activity__list session__list">
                      <div
                        v-for="(session, index) in session_data"
                        :key="index"
                      >
                        <transition name="fade">
                          <div
                            class="activity__list session__list"
                            :id="'session_' + index"
                          >
                            <div
                              class="activity__new activity__new--property pb-0"
                            >
                              <div class="activity__indicator mb-2">
                                <div
                                  :class="[
                                    session.vehicle_details.license_id != ''
                                      ? 'sessions_number_box text-center'
                                      : 'text-center sessions_number_box_vin',
                                  ]"
                                  @click="getOneSession(session, session_type)"
                                >
                                  <div
                                    class="
                                      txt--xs txt--red txt--bold
                                      images_state
                                    "
                                  >
                                    {{
                                      session.vehicle_details.state_full_name !=
                                      ""
                                        ? session.vehicle_details
                                            .state_full_name
                                        : session.vehicle_details.license_id !=
                                          ""
                                        ? session.vehicle_details.country
                                        : ""
                                    }}
                                    <!-- <img
                                      src="@/assets/images/car-number.png"
                                      alt
                                    />-->
                                  </div>
                                  <p
                                    class="
                                      txt--fsxs
                                      text-truncate
                                      txt--bold
                                      pt-1
                                    "
                                    v-if="
                                      session.vehicle_details.license_id != ''
                                    "
                                  >
                                    {{
                                      session.vehicle_details.license_id.toUpperCase()
                                    }}
                                  </p>
                                  <p v-else class="txt--fsxs txt--bold pt-1">
                                    {{
                                      session.vehicle_details.vin_id
                                        | last_eight(8, "##")
                                    }}
                                  </p>
                                </div>
                              </div>

                              <div
                                class="
                                  activity__txt activity__txt--property
                                  mb-2
                                "
                              >
                                <div
                                  class="
                                    sessions_start_duration
                                    text-right
                                    mr-3
                                  "
                                >
                                  <p
                                    class="txt--fsxs opacity--50 text-truncate"
                                  >
                                    Start
                                  </p>
                                  <p
                                    class="
                                      txt--fsxs
                                      opacity--50
                                      pt-2
                                      text-truncate
                                    "
                                  >
                                    Duration
                                  </p>
                                </div>
                                <div class="activity__msg txt--semi-bold">
                                  <p class="txt--fsxs text-truncate" v-tooltip="timezone">
                                    {{ session.booking_start_date_formatted }}
                                  </p>
                                  <p class="txt--fsxs pt-2 text-truncate">
                                    {{ session.stay_duration }}
                                    <!-- <span
                                      class="txt--primary pl-2"
                                      v-if="session_type == 1 || session.booking_end_date == ''"
                                      @click="
                                        endBook(
                                          session.booking_id,
                                          index,
                                          'list'
                                        )
                                      "
                                    >
                                      End Session
                                    </span> -->
                                    <span
                                      class="txt--primary pl-2"
                                      v-if="session_type == 1 || session.booking_end_date == ''"
                                      style="cursor: pointer"
                                    >
                                      <span
                                        class="txt--primary pl-2"
                                        v-if="hasAccess('session_access_write')"
                                        @click="
                                          endBook(
                                            session.booking_id,
                                            index,
                                            'list'
                                          )
                                        "
                                        style="cursor: pointer"
                                      >
                                        End Session
                                      </span>
                                      <span v-else-if="!session.booking_cancelled" class="txt--primary pl-2">
                                        Ongoing Session
                                      </span>
                                    </span>
                                    <span
                                      v-if="
                                        session_type == 2 &&
                                        session.customer_type != 2
                                      "
                                      class="pl-2"
                                    >
                                      {{
                                        "$" +
                                        session.price_breakdown.payable_amount
                                      }}
                                    </span>
                                  </p>
                                </div>
                              </div>

                              <div
                                class="
                                  activity__address activity__address--property
                                  mb-2
                                "
                              >
                                <p class="txt--xs opacity--50 text-truncate">
                                  {{
                                    session.property_name != ""
                                      ? session.property_name
                                      : session.display_address
                                  }}
                                </p>
                                <p
                                  class="txt--xs opacity--50 text-truncate pt-2"
                                >
                                  {{ session.customer_type_name }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                      <infinite-loading
                        @infinite="getSessionList"
                        :distance="10"
                        :identifier="sessionPagination.infiniteId"
                      >
                        <div slot="spinner">
                          <div class="d-flex justify-content-center mt-4">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div slot="no-more"></div>
                        <div slot="no-results">No data found</div>
                      </infinite-loading>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Property Avg Report Section -->
              <div class="col-12 mt-4 mb-4 mb-lg-0">
                <div
                  :class="['content__box', !report_access ? 'restricted' : '']"
                >
                  <div class="content__box__body">
                    <div class="row">
                      <!-- TRANSIENT CUSTOMER COUNT -->
                      <div
                        class="
                          col-sm-6 col-md-4 col-xl
                          mt-3 mt-md-0
                          customers-records
                        "
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("TC") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer">
                            <i
                              class="far fa-question-circle"
                              v-tooltip="helperTexts.transient_customer_count"
                            ></i>
                          </p>
                        </div>
                        <div v-if="transient_reload_btn == 0">
                          <div v-if="transient_loader">
                            <div class="d-flex justify-content-center">
                              <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <p class="txt--fslg pt-2">
                              {{ session_reports.transient_customer }}
                            </p>
                            <p
                              :class="[
                                'transient-customers-records txt--ss mt-3',
                                session_reports.transient_customer_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                              ]"
                            >
                              <span
                                :class="[
                                  session_reports.transient_customer_inc
                                    ? 'txt--green'
                                    : 'txt--red',
                                  'rounded-circle',
                                ]"
                              ></span>
                              {{ session_reports.transient_customer_inc_value }}%
                            </p>
                          </div>
                        </div>
                        <div v-else-if="transient_reload_btn == 1">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                            <button 
                              @click="getTransientReport" 
                              type="button" 
                              class="button button--primary button--sm mr-3 mt-2"
                            >
                              <span>Reload</span>
                            </button>
                        </div>
                      </div>
                      <!-- PERMIT CUSTOMER COUNT -->
                      <div
                        class="
                          col-sm-6 col-md-4 col-xl
                          mt-3 mt-md-0
                          customers-records
                        "
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("MC") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer">
                            <i
                              class="far fa-question-circle"
                              v-tooltip="helperTexts.permit_customer_count"
                            ></i>
                          </p>
                        </div>
                        <div v-if="permit_reload_btn == 0">
                          <div v-if="permit_customer_loader">
                            <div class="d-flex justify-content-center">
                              <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <p class="txt--fslg pt-2">
                              {{ session_reports.monthly_customer }}
                            </p>
                            <p
                              :class="[
                                'transient-customers-records txt--ss mt-3',
                                session_reports.monthly_customer_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                              ]"
                            >
                              <span
                                :class="[
                                  session_reports.monthly_customer_inc
                                    ? 'txt--green'
                                    : 'txt--red',
                                  'rounded-circle',
                                ]"
                              ></span>
                              {{ session_reports.monthly_customer_inc_value }}%
                            </p>
                          </div>
                        </div>
                        <div v-else-if="permit_reload_btn == 1">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getPermitCustomer" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                      </div>
                      <!-- ANONYMOUS CUSTOMER COUNT -->
                      <div
                        class="
                          col-sm-6 col-md-4 col-xl
                          mt-3 mt-xl-0
                          customers-records
                        "
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("AC") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer">
                            <i
                              class="far fa-question-circle"
                              v-tooltip="helperTexts.anonymous_customer_count"
                            ></i>
                          </p>
                        </div>
                        <div v-if="anonymous_reload_btn == 0">
                          <div v-if="!anonymous_customer_loader">
                            <p class="txt--fslg pt-2">
                              {{ session_reports.anonymous_customer }}
                            </p>
                            <p
                              :class="[
                                'transient-customers-records txt--ss mt-3',
                                session_reports.anonymous_customer_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                              ]"
                            >
                              <span
                                :class="[
                                  session_reports.anonymous_customer_inc
                                    ? 'txt--green'
                                    : 'txt--red',
                                  'rounded-circle',
                                ]"
                              ></span>
                              {{ session_reports.anonymous_customer_inc_value }}%
                            </p>
                          </div>
                          <div v-else>
                            <div class="d-flex justify-content-center">
                              <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="anonymous_reload_btn == 1">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getAnonymousCustomer" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                      </div>
                      <!-- AVERAGE SESSION DURATION -->
                      <!--{{--<div
                        class="
                          col-sm-6 col-md-4 col-xl
                          mt-3 mt-md-0
                          customers-records
                        "
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("AVGSD") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer">
                            <i
                              class="far fa-question-circle"
                              v-tooltip="helperTexts.avg_session_duration"
                            ></i>
                          </p>
                        </div>
                        <div v-if="avgSessionDuration_reload_btn == 0">
                          <div v-if="avg_session_loader">
                            <div class="d-flex justify-content-center">
                              <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <p class="txt--fslg pt-2">
                              {{
                                session_reports.avg_session_duration != ""
                                  ? session_reports.avg_session_duration
                                  : "0 sec"
                              }}
                            </p>
                            <p
                              :class="[
                                'transient-customers-records txt--ss mt-3',
                                session_reports.avg_session_duration_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                              ]"
                            >
                              <span
                                :class="[
                                  session_reports.avg_session_duration_inc
                                    ? 'txt--green'
                                    : 'txt--red',
                                  'rounded-circle',
                                ]"
                              ></span>
                              {{
                                session_reports.avg_session_duration_inc_value
                              }}%
                            </p>
                          </div>
                        </div>
                        <div v-else-if="avgSessionDuration_reload_btn == 1">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getAvgSessionReport" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                      </div>--}}-->
                      <!-- AVERAGE SESSION PRICE -->
                      <!--{{--<div
                        class="
                          col-sm-6 col-md-4 col-xl
                          mt-3 mt-xl-0
                          customers-records
                        "
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("AVGSP") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer">
                            <i
                              class="far fa-question-circle"
                              v-tooltip="helperTexts.avg_session_price"
                            ></i>
                          </p>
                        </div>
                        <div v-if="avgSessionPrice_reload_btn == 0">
                          <div v-if="avg_session_loader">
                            <div class="d-flex justify-content-center">
                              <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <p class="txt--fslg pt-2">
                              ${{ session_reports.avg_session_price }}
                            </p>
                            <p
                              :class="[
                                'transient-customers-records txt--ss mt-3',
                                session_reports.avg_session_price_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                              ]"
                            >
                              <span
                                :class="[
                                  session_reports.avg_session_price_inc
                                    ? 'txt--green'
                                    : 'txt--red',
                                  'rounded-circle',
                                ]"
                              ></span>
                              {{ session_reports.avg_session_price_inc_value }}%
                            </p>
                          </div>
                        </div>
                        <div v-else-if="avgSessionPrice_reload_btn == 1">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getAvgSessionPrice" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                      </div>--}}-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Session , Earning , Occupancy Chart -->
          <div class="col-lg-4">
            <div class="graph__area">
              <!-- OCCUPANCY CHART -->
              <div
                :class="[
                  'content__box content__box--graph h-50',
                  !report_access ? 'restricted' : '',
                ]"
              >
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <!-- <li :class="[occupancy_type == 1 ? 'active' : '']"
                      @click="getOccupancyChartData"
                      >
                        {{ $t("OCCUP") }}
                        <span class="ml-2 mt-2">
                          <i class="fas fa-info-circle"></i>
                        </span>
                      </li> -->
                      <li :class="[occupancy_type == 2 ? 'active' : '']"
                      @click="checkRealCount"
               
                      >
                        <!-- Real Time Occupancy -->
                        <!-- {{ $t("OCCUP") }} -->
                        Occupancy

                        <!-- <span class="ml-2 mt-2">
                          <i class="fas fa-info-circle"></i>
                        </span> -->
                      </li>
                    </ul>
                    <ul class="top__filter__ul">
                      <li :class="[occupancy_customer_type == 1 ? 'active' : '']"
                        @click="getOccupancyChartData(1)">
                        ALL                        
                      </li>
                      <li :class="[occupancy_customer_type == 2 ? 'active' : '']"
                        @click="getOccupancyChartData(2)">
                       Transient            
                      </li>
                      <li :class="[occupancy_customer_type == 3 ? 'active' : '', 'dropdown-container-activate']">
                        <span @click="getOccupancyChartData(3)">Permit</span>
                        <div class="dropdown-container">
                          <p
                            @click="getOccupancyChartData(3)"
                            :class="[occupancy_customer_type == 3 && permit_type_filter === 1 ? 'active' : '']"
                          >ALL</p>
                          <p
                            @click="getOccupancyChartData(3, 2)"
                            :class="[permit_type_filter === 2 ? 'active' : '']"
                          >Flex</p>
                          <p
                            @click="getOccupancyChartData(3, 3)"
                            :class="[permit_type_filter === 3 ? 'active' : '']"
                          >Recurring</p>
                        </div>                     
                      </li>
                      <li :class="[occupancy_customer_type == 4 ? 'active' : '']"
                         @click="getOccupancyChartData(4)">
                        Anonymous                        
                      </li>

                      <li class="active">
                        <i
                          class="far fa-question-circle"
                          v-tooltip="helperTexts.occupancy_chart"
                        ></i>
                      </li>
                    </ul>
                  </div>
                  <div v-if="occupancy_reload_btn == 0">
                    <div v-if="!occupancy_loader">
                      <h2 class="primaryHeader">{{ occupancy_total }}%</h2>
                      <!-- <p class="txt--ss" >{{report_type=='hour' ? 'Current' : 'Max'}}: {{occupancy_current}}%</p> -->
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          occupancy_inc ? 'txt--green' : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            occupancy_inc ? 'txt--green' : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{ occupancy_inc_percentage }}%
                      </p>
                    </div>
                  </div>
                  <div v-else-if="occupancy_reload_btn == 1">
                    <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                    <button 
                      @click="getOccupancyChartData(occupancy_customer_type)" 
                      type="button" 
                      class="button button--primary button--sm mr-3 mt-2"
                    >
                      <span>Reload</span>
                    </button>
                  </div>
                </div>
                <div v-if="occupancy_reload_btn == 0">
                  <div
                    class="content__box__body responsive__height pt-0"
                    v-if="!occupancy_loader"
                  >
                    <Occupancy :data="occupancy_chart" />
                  </div>
                  <div class="content__box__body responsive__height pt-0" v-else>
                    <div class="d-flex justify-content-center">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- SESSION / EARNING CHART -->
              <div
                :class="[
                  'content__box content__box--graph  mt-4 h-50',
                  !report_access ? 'restricted' : '',
                ]"
              >
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li
                        :class="[earning == 1 ? 'active' : '']"
                        @click="changeFilter(5)"
                      >
                        {{ $t("SESSION") }}
                      </li>
                      <li
                        :class="[earning == 2 ? 'active' : '']"
                        @click="changeFilter(6)"
                      >
                        {{ $t("EARN") }}
                      </li>
                    </ul>
                    <ul class="top__filter__ul">
                      <li :class="[earning_customer_type == 1 ? 'active' : '']"
                        @click="getSessionAndEarnings(earning,1)">
                        ALL                        
                      </li>
                      <li :class="[earning_customer_type == 2 ? 'active' : '']"
                        @click="getSessionAndEarnings(earning,2)">
                       Transient            
                      </li>
                      <li :class="[earning_customer_type == 3 ? 'active' : '', 'dropdown-container-activate']">
                            <span @click="getSessionAndEarnings(earning, 3)">Permit</span>
                            <div class="dropdown-container" v-if="earning === 1">
                              <p
                                @click="getSessionAndEarnings(earning, 3)"
                                :class="[earning_customer_type == 3 && earning_permit_type_filter === 1 ? 'active' : '']"
                              >ALL</p>
                              <p
                                @click="getSessionAndEarnings(earning, 3, 2)"
                                :class="[earning_permit_type_filter === 2 ? 'active' : '']"
                              >Flex</p>
                              <p
                                @click="getSessionAndEarnings(earning, 3, 3)"
                                :class="[earning_permit_type_filter === 3 ? 'active' : '']"
                              >Recurring</p>
                            </div>                     
                          </li>
                      <li :class="[earning_customer_type == 4 ? 'active' : '']"
                         @click="getSessionAndEarnings(earning,4)">
                        Anonymous                        
                      </li>

                      <li class="active">
                        <i
                          class="far fa-question-circle"
                          v-tooltip="
                            earning == 1
                              ? helperTexts.session_chart
                              : helperTexts.earning_chart
                          "
                        ></i>
                      </li>
                    </ul>
                  </div>
                  <div v-if="session_earning_reload_btn == 0">
                    <div v-if="!session_earning_loader">
                      <h2 class="primaryHeader">
                        {{
                          earning == 2
                            ? "$" + session_earning_chart_total
                            : session_earning_chart_total
                        }}
                      </h2>
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          session_earning_chart_inc ? 'txt--green' : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            session_earning_chart_inc ? 'txt--green' : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{ session_earning_chart_percentage }}%
                      </p>
                    </div>
                  </div>
                  <div v-else-if="session_earning_reload_btn == 1">
                    <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                    <button 
                      @click="getSessionAndEarnings(earning,earning_customer_type)" 
                      type="button" 
                      class="button button--primary button--sm mr-3 mt-2"
                    >
                      <span>Reload</span>
                    </button>
                  </div>
                </div>
                <div v-if="session_earning_reload_btn == 0">
                  <div
                    class="content__box__body responsive__height pt-0"
                    v-if="!session_earning_loader"
                  >
                    <SessionChart v-if="earning == 1" :data="session_chart" />
                    <Chart :data="session_chart" :chart_type="earning" v-else />
                  </div>
                  <div class="content__box__body responsive__height pt-0" v-else>
                    <div class="d-flex justify-content-center">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                  <!-- <div :class="['content__box content__box--graph mt-4 h-50',!report_access ? 'restricted' : '']">
                    <div class="content__box__header">
                      <div class="top__filter">
                        <ul class="top__filter__ul">
                          <li
                            :class="[earning == 1 ? 'active' : '']"
                            @click="changeFilter(5)"
                          >
                            {{ $t("SESSION") }}
                          </li>
                          <li
                            :class="[earning == 2 ? 'active' : '']"
                            @click="changeFilter(6)"
                          >
                            {{ $t("EARN") }}
                          </li>
                        </ul>

                        <ul class="top__filter__ul">
                          <li class="active"><i class="far fa-question-circle" v-tooltip="earning==1 ? helperTexts.session_chart : helperTexts.earning_chart"></i></li>
                        </ul>
                      </div>
                      <div v-if="session_earning_reload_btn == 0">
                        <h2 class="primaryHeader">
                          {{
                            earning == 2
                              ? "$" + session_earning_chart_total
                              : session_earning_chart_total
                          }}
                        </h2>
                        <p
                          :class="[
                            'transient-customers-records txt--ss mt-3',
                            session_earning_chart_inc
                              ? 'txt--green'
                              : 'txt--red',
                          ]"
                        >
                          <span
                            :class="[
                              session_earning_chart_inc
                                ? 'txt--green'
                                : 'txt--red',
                              'rounded-circle',
                            ]"
                          ></span>
                          {{ session_earning_chart_percentage }}%
                        </p>
                      </div>
                      <div v-else-if="session_earning_reload_btn == 2">
                        <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                        <button @click="getSessionAndEarnings" type="button" class="button button--primary button--sm mr-3 mt-2">Reload</button>
                      </div>
                    </div>
                    <div
                      class="content__box__body responsive__height pt-0"
                      v-if="session_earning_reload_btn == 0"
                    >
                      <SessionChart v-if="earning==1" :data="session_chart"/>
                      <Chart :data="session_chart" :chart_type="earning" v-else/>
                    </div>
                    <div
                      class="content__box__body responsive__height pt-0"
                      v-else-if="session_earning_reload_btn == 1"
                    >
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div> -->


            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <ValidationModal />
    <SessionDetails
      @session_removed="refreshSessionList"
      @session_delete="sessionAfterDelete"
      @session_reload="resetSessionList"
    />
    <liveView
        :space_id="space_id"
        :laneDevices="laneDevices"
    />
    <MonthlySubscriptionForm
      v-if="Object.keys(space_details).length > 0"
      :space_id="space_id"
      :file_name="space_details.monthly_customer_form"
      :monthly_application_fee="space_details.price.monthly_application_fee"
      :monthly_application_fee_type="space_details.price.application_fee_type"
      @modal_closed="getPropertyDetails"
    />
    <Review
      v-if="Object.keys(space_details).length > 0"
      :space_id="space_id"
      @modal_closed="getPropertyDetails"
    />
    <!-- <monthlyCustomer
      v-if="Object.keys(space_details).length > 0"
      :space_id="space_id"
      :space_details="space_details"
      :monthly_application_fee="space_details.price.monthly_application_fee"
      :monthly_application_fee_type="space_details.price.application_fee_type"
      @modal_closed="getPropertyDetails"
    /> -->

    <PermitCustomer
      v-if="Object.keys(space_details).length > 0 && amenity_list.length > 0"
      :search_from_property='search_from_property'
      @modal_closed="getPropertyDetails"
    />

    <propertyEditDetails
      v-if="Object.keys(space_details).length > 0 && amenity_list.length > 0"
      :property_details="space_details"
      :amenity="amenity_list"
      @modal_closed="getPropertyDetails"
    />
    <PropertyAvailability
      v-if="Object.keys(space_details).length > 0"
      :property_details="space_details"
      @modal_closed="getPropertyDetails"
    />
    <propertyPricing
      v-if="Object.keys(space_details).length > 0"
      @modal_closed="getPropertyDetails"
    />
    <propertyImageUpload
      v-if="Object.keys(space_details).length > 0"
      :property_details="space_details"
      @modal_closed="getPropertyDetails"
    />
  </div>
</template>

<script>
import StarRating from "@/components/StarRating";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Chart from "@/components/ChartDrill";
import Occupancy from "@/components/ChartOccupancy";
import liveView from "@/components/modals/liveView";
// import monthlyCustomer from "@/components/modals/monthlyCustomer";
import PermitCustomer from "@/components/modals/PermitCustomer";
import ValidationModal from "@/components/modals/Validations";
import propertyEditDetails from "@/components/modals/propertyEditDetails";
import PropertyAvailability from "@/components/modals/propertyAvailabilty";
import PropertyPricing from "@/components/modals/propertyPricing";
import PropertyImageUpload from "@/components/modals/propertyImage";
import Review from "@/components/modals/Review";
import MonthlySubscriptionForm from "@/components/modals/monthlySubscriptionForm";
import commonservices from "../../services/CommonService";
import SessionDetails from "@/components/modals/sessionDetails";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import helperTexts from "@/assets/data/helperText";
import SessionChart from "@/components/sessionChart";
import Vue from 'vue';
import Toggle from "@/components/toggle";
const service = new commonservices();

export default {
  name: "Property",
  components: {
    SessionChart,
    ValidationModal,
    "stars-rating": StarRating,
    VueSlickCarousel: VueSlickCarousel,
    Chart: Chart,
    Occupancy: Occupancy,
    liveView: liveView,
    // monthlyCustomer: monthlyCustomer,
    propertyEditDetails: propertyEditDetails,
    PropertyAvailability: PropertyAvailability,
    propertyPricing: PropertyPricing,
    propertyImageUpload: PropertyImageUpload,
    Review: Review,
    MonthlySubscriptionForm: MonthlySubscriptionForm,
    SessionDetails: SessionDetails,
    datetime: Datetime,
    PermitCustomer,
  },
  data() {
    return {
      property_timezone: '',
      timezone: '',
      helperTexts: {},
      //property section
      admin_access: false,
      administrator: "",
      msg: "This property is incomplte",
      showContactdetails: false,
      booking_user_id: "",
      vehicle_no: "",
      spaceName: "",
      property_name: "",
      space_id: null,
      amenity_list: {},
      space_details: [],
      usrconfig: {
        rating: 3.7,
        isIndicatorActive: false,
        style: {
          fullStarColor: "#f5a623",
          emptyStarColor: "#737373",
          starWidth: 16,
          starHeight: 16,
        },
      },
      //Activity variables
      carouselSettings: {
        arrows: true,
        dots: false,
        variableWidth: true,
        infinite: false,
        centerMode: true,
        focusOnSelect: false,
        swipeToSlide: false,
        swipe: true,
        vertical: false,

        initialSlide: this.$moment().date() - 1,
      },
      month_list: [],
      currentMonth: null,
      currentYear: this.$moment().year(),
      currentMonthDate: this.$moment().month() + 1,
      currentMonthName: this.$moment().format("MMMM"),
      today: this.$moment().date(),
      currentDate: this.$moment().format("YYYY-MM-DD"),
      month_selector: this.$moment().month() + 1,
      activedate: null,
      activity_list: [],
      activity_sorce: null,
      activityPagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
      },
      // activity_loader: false,
      // session variables
      start_date: "",
      end_date: "",
      minDatetime: "2020-01-01T16:32:49.145+05:30",
      maxDatetime: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      sessionsFilter: false,
      active_session: 1,
      session_type: 1,
      session_filter: 0,
      session_source: null,
      session_search: "",
      // session_loader: false,
      session_data: [],
      session_data_temp: [],
      sessionPagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
      },
      //session variables end
      validation_access: false,
      gate_images: [],
      //=========== Report Section ============//
      report_access: true,
      report_type: "hour",
      report_filter: 7,
      report_from: this.$moment().format("YYYY-MM-DD"),
      report_to: this.$moment().format("YYYY-MM-DD"),
      //bottom report section
      avg_session_loader: false,
      avg_source: null,
      avg_price_source: null,
      avg_session_price_loader: false,
      transient_source: null,
      transient_loader: false,
      permit_customer_source: null,
      permit_customer_loader: false,
      anonymous_customer_source: null,
      anonymous_customer_loader: false,
      first_year: 2018,
      years: [],
      session_reports: {
        anonymous_customer: 0,
        anonymous_customer_inc: true,
        anonymous_customer_inc_value: "+" + 0,
        monthly_customer: 0,
        monthly_customer_inc: true,
        monthly_customer_inc_value: "+" + 0,
        avg_session_duration: 0,
        avg_session_duration_inc: true,
        avg_session_duration_inc_value: "+" + 0,
        avg_session_price: 0,
        avg_session_price_inc: true,
        avg_session_price_inc_value: "+" + 0,
        transient_customer: 5097,
        transient_customer_inc: true,
        transient_customer_inc_value: "+" + 33.45,
      },
      //bottom report section end
      //==== session & earning report section==//
      session_earning_loader: false,
      earning: 1,
      session_chart: [],
      session_earning_chart_total: 0,
      session_earning_chart_percentage: "+0.00",
      session_earning_chart_inc: true,
      session_earning_source: null,
      //======== Occupancy report section =======//
      occupancy_loader: false,
      occupancy_chart: [],
      occupancy_total: 0.0,
      occupancy_current: 0,
      occupancy_inc: true,
      occupancy_inc_percentage: "+0.00",
      occupancy_source: null,
      validation_id:null,
      search_from_property:'',
      occupancy_type:2,
      user_role:    '',
      access_list:  {},
      transient_reload_btn:           0,
      permit_reload_btn:              0,
      anonymous_reload_btn:           0,
      avgSessionDuration_reload_btn:  0,
      avgSessionPrice_reload_btn:     0,
      occupancy_reload_btn:           0,
      session_earning_reload_btn:     0,
      propertyDetailsLoader     :false,
      controlGates: false,
      laneDevices: [],
      occupancy_customer_type: 1,
      earning_customer_type: 1,
      permit_type_filter: 1,
      earning_permit_type_filter: 1,
    };
  },
  filters: {
    last_eight: function (text, length, suffix) {
      let full_length = text.length;
      if (full_length > length) {
        return suffix + text.substr(full_length - length);
      } else {
        return text;
      }
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          // // console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        // console.log(binding);
      },
    },
  },

  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = this.getAccessList();

    this.helperTexts = helperTexts;
    this.space_id = this.$route.query.p;

    if (!this.space_id) {
      this.$router.push({ name: "Dashboard" });
    }
    window.EventBus.$on("access_update", () => {
      this.reportAccess();
    });
    if (
      localStorage.getItem("admin_access") &&
      localStorage.getItem("admin_access") == "true"
    ) {
      this.admin_access = true;
    }
    this.getPropertyDetails();
    // this.getSessionList();
    this.amenities();
    // this.getGateImages();
    this.getDaysArray(this.currentYear, this.currentMonthDate);
    // let date =
    //   this.currentYear + "-" + this.currentMonthDate + "-" + this.today;
    // this.getActivityList(date);

    let datas = this.first_year;
    for (datas; datas <= this.currentYear; datas++) {
      //alert(datas);
      this.years.push({
        name: datas,
        value: datas,
      });
      // alert(this.years[0].name);
    }
    window.EventBus.$on("report_switcher", (data) => {
      switch (data) {
        case 1:
          this.changeFilter(7);
          break;
        case 2:
          this.changeFilter(8);
          break;
        case 3:
          this.changeFilter(9);
          break;
        case 4:
          this.changeFilter(10);
          break;
        default:
          window.location.refresh();
          break;
      }
    });
    this.checkRealCount();
  },
  mounted() {
    this.getMonthList();
    this.reportAccess();
    // this.$router.replace({query: null});
  },
  beforeUpdate(){
    // // console.log(this.$route.query)
    if(this.$route.query.redirect !== 'undefined'){
      if(this.$route.query.redirect == 'property_search' && this.$route.query.data){
        this.search_from_property = this.$route.query.data;
        this.openModal('permit-customer');
      }
    }
  // console.log(this.$route.query)
    // this.$router.replace({'query': null});
    // this.openModal('permit-customer');
  },
  beforeDestroy() {
    // window.EventBus.$emit("week_switcher");
  },
  destroyed(){
  },
  watch: {
    session_search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.searchSession();
      }
    },
    start_date: function (newValue, oldValue) {
      if (newValue.trim() != oldValue.trim() && newValue.trim() != "") {
        this.checkDate();
      }
    },
    end_date: function (newValue, oldValue) {
      if (newValue.trim() != oldValue.trim() && newValue.trim() != "") {
        this.checkDate();
      }
    },
  },
  methods: {
    getAccessList() {
        try {
            return JSON.parse(localStorage.getItem("commercial_access_list")) || {};
        } catch {
            return {};
        }
    },
    hasAccess(permission_name) {
        return this.admin_access
            || this.user_role === 'commercial'
            || this.user_role === 'operator' && !!this.access_list[permission_name];
    },
    getSessionAndEarnings(type, cust_type, permit_type = 1)
    {
      this.earning_permit_type_filter = permit_type;
      this.earning = type;
      this.earning_customer_type = cust_type;
      if (this.earning == 1) {
        this.getSessionChartData(cust_type);
      } else {
        this.getEarningChartData(cust_type);
      }
    },
    reportAccess() {
      const access = this.getAccessList();

      if (Object.keys(access).length) {
        if (Object.keys(access).includes("report_access")) {
          this.report_access = access.report_access;
        }
        if (Object.keys(access).includes("validation_access")) {
          this.validation_access = access.validation_access;
        }

      }

      if (this.report_access) {
        // this.getAvgSessionReport();
        // this.getAvgSessionPrice();
        this.getTransientReport();
        this.getPermitCustomer();
        this.getAnonymousCustomer();
        this.getSessionChartData(this.earning_customer_type);
        this.getOccupancyChartData(this.occupancy_customer_type);
      }
    },
    closeDropdown() {
      this.sessionsFilter = false;
    },
    getMonthList() {
      this.month_list = [];
      //alert(this.currentMonthDate);
      for (let i = 1; i <= this.currentMonthDate; i++) {
        var d = "";
        if (i < 10) {
          d = this.currentYear + "-0" + i + "-01";
        } else {
          d = this.currentYear + "-" + i + "-01";
        }
        this.month_list.push({
          name: this.$moment(d).format("MMMM"),
          value: this.$moment(d).month() + 1,
        });
      }
      if (this.currentYear != this.$moment().year()) {
        // it reset to jan for all years except the current year
        this.currentMonthDate = 1; // for current year it display the current date with the current month selected by default when change evnt occur
      }
    },
    openModal(modalName) {
      this.$modal.show(modalName, {
        property_details: this.space_details,
      });
    },
    async getPropertyDetails() {
      this.propertyDetailsLoader = true;
      this.space_details = [];
      await this.axios
        .post(window.hostname + "api/auth/all-space", {
          space_id: this.space_id,
          device_type: 1,
          minify: 1,
          minify_2: 0,
          time_zone: null,
        })
        .then((res) => {
          if (res.data.status) {
            this.space_details = res.data.data;
            if (Object.keys(this.space_details).length == 0) {
              this.$toasted.show("Property details are not found!", {
                icon: "times-circle",
                className: "error-class",
              });
              this.$router.push("/dashboard");
            }
            let prop_name = this.space_details.location.address;
            let prop_arr = prop_name.split(",");
            this.spaceName = prop_arr[0];
            this.property_name =
              this.space_details.details.property_name != "" &&
              typeof this.space_details.details.property_name != "undefined"
                ? this.space_details.details.property_name
                : prop_arr[0];
            this.property_timezone = this.space_details.location.time_zone;
            this.usrconfig.rating = res.data.data.rating;
            this.laneDevices = res.data.data.devices;
            this.controlGates = res.data.data.control_gates;
            this.minDatetime =
              this.space_details.created_at &&
              this.space_details.created_at != ""
                ? this.$moment(this.space_details.created_at).format(
                    "YYYY-MM-DDTHH:mm:ss.sssZ"
                  )
                : this.$moment(
                    this.space_details.availability.start_date
                  ).format("YYYY-MM-DDTHH:mm:ss.sssZ");
            window.EventBus.$emit("rating_update", this.usrconfig);
            this.propertyDetailsLoader =false;
          } else {
            this.space_details = [];
            this.$toasted.show("Property details are not found!", {
              icon: "times-circle",
              className: "error-class",
            });
            this.$router.push("/dashboard");
            this.usrconfig.rating = 0;
            window.EventBus.$emit("rating_update", this.usrconfig);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async amenities() {
      await this.axios
        .post(window.hostname + "/api/auth/amenities")
        .then((res) => {
          if (res.data.status) {
            this.amenity_list = res.data.data;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //=================session methods=====================//
    resetSessionList(){
      this.session_data = [];
      this.getSessionList(1);
    },
    getSessionList($state) {
      
      // this.session_loader = true;
      if (this.session_source) {
        this.session_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_source = CancelToken.source();
      this.axios
        .post(
          window.hostname + "/api/auth/booking",
          {
            page: this.sessionPagination.page,
            space_id: this.space_id,
            mode: "show-booking",
            booking_for: "owner",
            booking_type: 1,
            session_type: this.session_type,
            filter: this.session_filter,
            search_param: this.session_search,
            booking_user_id: this.booking_user_id,
            time_zone: this.$moment.tz.guess(new Date()),
            start_date:
              this.start_date != ""
                ? this.$moment(this.start_date).format("YYYY-MM-DD")
                : "",
            end_date:
              this.end_date != ""
                ? this.$moment(this.end_date).format("YYYY-MM-DD")
                : "",
          },
          {
            cancelToken: this.session_source.token,
          }
        )
        .then((res) => {
          // this.session_loader = false;
          // // console.log('session',res.data);
          if (res.data.status) {
            let sessions = res.data.data.booking_details;
            this.timezone = res.data.data.timezone
            if (!this.start_date && res.data.data.start_date) {
              this.start_date = res.data.data.start_date;
            }
            this.session_data_temp = this.session_data;
            sessions.map((val) => {
                // alert("val.booking_id>>>"+val.booking_id);
                var index = this.session_data_temp.map(function(o) { return o.booking_id; }).indexOf(val.booking_id);
                if (index==-1){
                  this.session_data.push(val);
                }           
            });
            this.sessionPagination.page = res.data.data.pagination.page;
            this.sessionPagination.load_more =
              res.data.data.pagination.load_more == 1 ? true : false;
            if (!this.sessionPagination.load_more) {
              $state.loaded();
              $state.complete();
            } else {
              $state.loaded();
            }
          } else {
            this.session_data = [];
            $state.complete();
          }
        })
        .catch((err) => {
          // console.log(err);
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
            // this.session_loader = true;
          } else {
            // console.log(err);
            // this.session_loader = false;
            $state.error();
          }
        });
        // console.log(">>>>>list"+this.session_data);
    },
    sessionFilter(filter) {
      this.session_data = [];
      this.session_type = filter;

      this.sessionPagination.page = 1;
      this.sessionPagination.load_more = true;
      // this.getSessionList();
      this.sessionPagination.infiniteId += 1;
    },
    sessionCustomerFilter(filter) {
      this.session_filter = filter;
      this.session_data = [];
      this.sessionPagination.page = 1;
      this.sessionPagination.load_more = true;
      // this.getSessionList();
      this.sessionPagination.infiniteId += 1;
    },
    checkDate() {
      if (this.start_date != "" && this.end_date != "") {
        let start = this.$moment(this.start_date).format("YYYY-MM-DD HH:mm");
        let end = this.$moment(this.end_date).format("YYYY-MM-DD HH:mm");

        if (this.$moment(end).diff(start) < 0) {
          this.$toasted.show("Please select a valid date range!", {
            icon: "times-circle",
            className: "error-class",
          });

          this.$nextTick(() => {
            this.end_date = "";
          });
          return;
        }
      }
      this.searchSession();
    },
    searchSession() {
      this.session_data = [];
      this.sessionPagination.page = 1;
      this.sessionPagination.load_more = true;
      this.sessionPagination.infiniteId += 1;
    },
    sessionAfterDelete(event){
      //delete feature only for anonymous user's session
      var index = this.session_data.map(function(o) { return o.booking_id; }).indexOf(event.session_id);
      if(index>-1){
        this.$delete(this.session_data, index);
      }
      // this.checkSessionLength();
       this.activity_list = [];
       this.activityPagination.page = 1;
       this.activedate = null;
       this.activityPagination.infiniteId += 1;   
    },
    getOneSession(session, session_type) {
      let validation_id = null;
      if (session.validation && session.validation.validation_id) {
        validation_id = session.validation.validation_id;
      }
      this.$modal.show("session-details", {
        timezone: this.timezone,
        data: session,
        session_type: session_type,
        property_id: this.space_id,
        validation_id: validation_id,
        property_timezone: this.property_timezone,
      });
    },
    //get gate images
    getGateImages() {
      this.axios
        .post(window.hostname + "api/auth/booking", {
          space_id: this.space_id,
          booking_for: "owner",
          mode: "today-session-image",
          device_type: 1,
        })
        .then((res) => {
          if (res.data.status) {
            this.gate_images = res.data.data.booking_details;
          } else {
            this.gate_images = [];
          }
          // console.log(this.gate_images);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //end session
    endBook(booking_id, index, type) {
      let end_date = this.$moment(new Date()).utc().format();
      let isDatetimeVisible = false;
      let timezone = this.property_timezone;
      const self = this;
      this.$swal({
        html:`
          <p class="txt--ss font-weight-bold txt--off-white">Are you sure you want to end this session?</p>
          <div id="datetime-end_date">
          </div>
        `,
        showCancelButton: true,
        onOpen: () => {
          Vue.component('datetime', Datetime);
          const SwalDatetime = new Vue({
            data: function() {
              return {
                isDatetimeVisible: isDatetimeVisible,
              };
            },
            methods: {
              toggleDatetime() {
                this.isDatetimeVisible = !this.isDatetimeVisible;
                isDatetimeVisible = this.isDatetimeVisible;

                this.$refs.toggle1.active = !this.isDatetimeVisible;
                this.$refs.toggle2.active = this.isDatetimeVisible;
              },
              handleDatetimeInput(newValue) {
                if (newValue) {
                  end_date = this.$moment(newValue).utc().format();
                }
              },
            },
            render: function (createElement) {
              return createElement('div',
              {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "fit-content"
                },
              },
              [
              createElement(Toggle, {
                  ref: 'toggle1',
                  props: {
                    label: 'End at grace period',
                    checked: !this.isDatetimeVisible
                  },
                  on: {
                    'update:checked': this.toggleDatetime
                  }
                }),
                createElement('div',
                {
                  style: {
                    display: "flex",
                  }
                },
                [
                  createElement(Toggle, {
                    ref: 'toggle2',
                    props: {
                      label: 'End at custom time',
                      checked: this.isDatetimeVisible
                    },
                    on: {
                      'update:checked': this.toggleDatetime
                    }
                  }),
                  createElement('datetime', {
                    ref: 'datetime',
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd hh:mm a",
                      "input-class": [
                        'hidden_input'
                      ],
                      "value-zone": timezone,
                      zone: timezone,
                    },
                    class: ["dateTime__picker"],
                    style: {
                      visibility: this.isDatetimeVisible ? "visible" : "hidden",
                    },
                    directives: [
                      {
                        name: 'tooltip',
                        value: timezone,
                        modifiers: {
                          placement: 'top'
                        }
                      }
                    ],
                    value: end_date,
                    on: {
                      input: this.handleDatetimeInput,
                    },
                  }),
                ]),
              ]);
            },
          }).$mount();

          document.getElementById('datetime-end_date').appendChild(SwalDatetime.$el);
          SwalDatetime.$refs.datetime.setValue({target: { value: end_date}});
        },
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }
        if (self.session_type != 0) {
          self.$delete(self.session_data, index);
        }
        if (result.value) {
          self.axios
            .post(window.hostname + "api/auth/booking", {
              device_type: 1,
              mode: "make-payment",
              admin_confirm: 1,
              end_session: 1,
              booking_id: booking_id,
              time_zone: this.$moment.tz.guess(),
              trigger: "Operator",
              end_date: isDatetimeVisible ? end_date : null
            })
            .then((res) => {
              if (res.data.status) {
                if (self.session_type == 0) {
                  self.session_data[index].booking_end_date =
                    res.data.data.booking_end_date;
                  self.session_data[index].price_breakdown =
                    res.data.data.price_breakdown;

                  self.session_data[index].stay_duration = self.getDuration(
                    self.session_data[index].booking_start_date,
                    self.session_data[index].booking_end_date
                  );
                }
                self.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
              } else {
                self.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
              self.checkSessionLength(type);
            })
            .catch((error) => {
              console.log(error.response.data.message);
            });
          return;
        }
      });
    },
    refreshSessionList(event) {
      let index = this.session_data.indexOf(event.session);
      if (this.session_type != 0) {
        this.$delete(this.session_data, index);
      } else {
        this.session_data[index].booking_end_date =
          event.response.booking_end_date;
        this.session_data[index].price_breakdown =
          event.response.price_breakdown;

        this.session_data[index].stay_duration = this.getDuration(
          this.session_data[index].booking_start_date,
          this.session_data[index].booking_end_date
        );
      }
      this.checkSessionLength();
      // let m = parseInt(this.$moment().month()) + 1 ;
      // let date = this.$moment().year() + "-" + m + "-" + this.$moment().date();
      this.activity_list = [];
      this.activityPagination.page = 1;
      this.activedate = null;
      this.activityPagination.infiniteId += 1;
      // this.getActivityList(date);
    },
    checkSessionLength(type) {
      let length = this.session_data.length;
      if (length <= 6) {
        this.sessionFilter(this.session_type);
      }
    },
    getDuration(start_time, end_time) {
      var start = this.$moment(start_time).format("YYYY-MM-DD HH:mm:ss");
      var end = this.$moment(end_time).format("YYYY-MM-DD HH:mm:ss");

      var duration = this.$moment(end).diff(start);
      duration = duration / 1000;
      var data = "";
      var days = parseInt(parseInt(duration) / (3600 * 24));
      days = parseInt(days);
      if (days > 0) {
        data += days + " days ";
      }

      /*** get the hours ***/
      var hours = (parseInt(duration) / 3600) % 24;
      hours = parseInt(hours);
      if (hours > 0) {
        data += hours + " hrs ";
      }

      /*** get the minutes ***/
      var minutes = (parseInt(duration) / 60) % 60;
      minutes = parseInt(minutes);
      if (minutes > 0) {
        data += minutes + " mins ";
      }

      /*** get the seconds ***/
      var seconds = parseInt(duration) % 60;
      seconds = parseInt(seconds);
      if (seconds > 0 && hours <= 0 && minutes <= 0) {
        data += seconds + " secs";
      }
      return data;
    },
    clearDates() {
      this.start_date = "";
      this.end_date = "";
      this.searchSession();
    },
    //======================session methods end===================//

    //activity methods start
    getDaysByMonth(month) {
      const daysInMonth = this.$moment(month).daysInMonth();
      return Array.from({ length: daysInMonth }, (v, k) => k + 1);
    },
    focusDate(i, e) {
      if (i > this.today - 1) {
        e.stopPropagation();
      } else {
        this.activedate = i;
        // let date =
        //   this.currentYear + "-" + this.currentMonthDate + "-" + (i + 1);
        this.activityPagination.page = 1;
        this.activity_list = [];
        // this.getActivityList(date);
        this.activityPagination.infiniteId += 1;
      }
    },
    changeActivityYear() {
      if (this.currentYear == this.$moment().year()) {
        this.currentMonthDate = this.$moment().month() + 1;
      } else {
        this.currentMonthDate = 12;
      }
      this.getMonthList();
      this.changeActivityMonth();
    },
    changeActivityMonth() {
      if (
        this.currentYear == this.$moment().year() &&
        this.currentMonthDate == this.$moment().month() + 1
      ) {
        this.today = this.$moment().date();
      } else {
        let date =
          this.currentMonthDate < 10
            ? this.currentYear + "-0" + this.currentMonthDate + "-01"
            : this.currentYear + "-" + this.currentMonthDate + "-01";
        this.today = this.$moment(date).endOf("month").date();
      }
      //alert(this.currentYear+"month>>"+this.currentMonthDate);
      this.getDaysArray(this.currentYear, this.currentMonthDate);
      //alert("TTTTT"+this.today);
      if (
        this.currentYear == this.$moment().year() &&
        this.currentMonthDate == this.$moment().month() + 1
      ) {
        this.focusDate(this.today - 1, "");
      } else {
        this.focusDate(0, "");
      }
    },
    getDaysArray(year, month) {
      const monthIndex = month - 1;
      const names = Object.freeze([
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
      ]);
      const date = new Date(year, monthIndex, 1);
      const result = [];
      while (date.getMonth() == monthIndex) {
        // result.push(`${date.getDate()}-${names[date.getDay()]}`);
        result.push({
          date: date.getDate(),
          day: names[date.getDay()],
          full_date: this.$moment(date).format("YYYY-MM-DD"),
        });
        date.setDate(date.getDate() + 1);
      }
      this.currentMonth = result;
    },
    getActivities($state) {
      let day = null;

      if (this.activedate == null) {
        day = this.today;
      } else {
        day = this.activedate + 1;
      }
      let currentMonthDate = this.currentMonthDate;
      if (this.currentMonthDate < 10) {
        currentMonthDate = "0" + currentMonthDate;
      }
      if (day < 10) {
        day = "0" + day;
      }
      let date = this.currentYear + "-" + currentMonthDate + "-" + day;

      if (this.activity_sorce) {
        this.activity_sorce.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.activity_sorce = CancelToken.source();
      if (this.admin_access) {
        this.administrator = 1;
      }
      this.axios
        .post(
          window.hostname + "/api/auth/activity-list",
          {
            device_type: 1,
            space_id: this.space_id,
            page: this.activityPagination.page,
            limit: 10,
            date: date,
            time_zone: this.$moment.tz.guess(),
            administrator: this.administrator,
          },
          {
            cancelToken: this.activity_sorce.token,
          }
        )
        .then((res) => {
          // // console.log("activity", res.data);
          if (res.data.status) {
            if (res.data.data.activity_list) {
              let activity = res.data.data.activity_list;
              activity.map((data) => {
                this.activity_list.push(data);
              });
              this.activityPagination.load_more =
                res.data.data.pagination.load_more == 1 ? true : false;
              this.activityPagination.page = res.data.data.pagination.page;
              $state.loaded();
              if (!this.activityPagination.load_more) {
                $state.complete();
              }
            } else {
              this.activity_list = [];
              this.activityPagination.page = 1;
              this.activityPagination.load_more = false;
              $state.complete();
            }
          } else {
            this.activity_list = [];
            this.activityPagination.page = 1;
            this.activityPagination.load_more = false;
            $state.complete();
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
          } else {
            $state.error();
          }
        });
    },
    //activity methods end
    changeFilter(filter) {
      switch (filter) {
        case 1:
          this.active_session = 1;
          break;
        case 2:
          this.active_session = 2;
          break;
        case 3:
          this.active_session = 3;
          break;
        case 4:
          this.active_session = 4;
          break;
        case 5: // toggle from earning to session
          this.earning = 1;
          this.getSessionChartData(this.earning_customer_type);
          break;
        case 6: // toggle from session to earning
          this.earning = 2;
          this.getEarningChartData(this.earning_customer_type);
          break;
        case 7: // get hourly session / earning / Occupancy report
          // this.session_filter = 1;
          this.session_chart_report_type = "hour";

          this.report_filter = filter;
          this.report_type = "hour";
          this.report_from = this.$moment().format("YYYY-MM-DD");
          this.report_to = this.$moment().format("YYYY-MM-DD");
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          break;
        case 8: // get weekly session / earning / Occupancy report
          // this.session_filter = 2;
          this.session_chart_report_type = "week";
          this.report_filter = filter;
          this.report_type = "week";
          this.report_from = this.$moment()
            .add(-7, "days")
            .format("YYYY-MM-DD");
          this.report_to = this.$moment().add(-1, "days").format("YYYY-MM-DD");
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          break;
        case 9: // get monthly session / earning / Occupancy report
          // this.session_filter = 3;
          this.session_chart_report_type = "month";
          this.report_filter = filter;
          this.report_type = "month";
          this.report_from = this.$moment()
            .startOf("year")
            .format("YYYY-MM-DD");
          this.report_to = this.$moment().endOf("month").format("YYYY-MM-DD");
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          break;
        case 10: // get yearly session / earning / Occupancy report
          // this.session_filter = 4;
          // this.session_chart_report_type = "year";
          this.report_filter = filter;
          this.report_type = "year";
          this.report_from = "2018-01-01";
          this.report_to = this.$moment().endOf("month").format("YYYY-MM-DD");
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          break;
        // case 11: // get hourly occupancy report
        //   this.occupancy_filter = 1;
        //   this.occupancy_chart_report_type = "hour";
        //   this.getOccupancyChartData();
        //   break;
        // case 12: // get weekly occupancy report
        //   this.occupancy_filter = 2;
        //   this.occupancy_chart_report_type = "week";
        //   this.getOccupancyChartData();
        //   break;
        // case 13: // get monthly occupancy report
        //   this.occupancy_filter = 3;
        //   this.occupancy_chart_report_type = "month";
        //   this.getOccupancyChartData();
        //   break;
        // case 14: // get yearly occupancy report
        //   this.occupancy_filter = 4;
        //   this.occupancy_chart_report_type = "year";
        //   this.getOccupancyChartData();
        //   break;
        default:
          window.location.refresh();
          break;
      }
    },
    //bottom report methods
    getTransientReport() {
      if (this.transient_source) {
        this.transient_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.transient_source = CancelToken.source();

      this.transient_loader = true;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/transient-customers",
          {
            device_type: 1,
            commercial: 1,
            space_id: this.space_id,
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.transient_source.token,
          }
        )
        .then((res) => {
          this.transient_loader = false;
          this.transient_reload_btn   = 0;
          if (!res.data.status) {
            return;
          }
          this.transient_loader = false;
          let response = service.getCalculateData(
            res.data.data.current_transient_customer_count,
            res.data.data.past_transient_customer_count
          );
          this.session_reports.transient_customer =
            res.data.data.current_transient_customer_count;
          this.session_reports.transient_customer_inc_value = response.data_inc;
          this.session_reports.transient_customer_inc =
            response.data_inc_status;
        })
        .catch((err) => {
          this.transient_reload_btn   = 1;
          if (this.axios.isCancel(err)) {
            // // console.log("Request canceled", err);
            this.transient_loader = true;
          } else {
            this.transient_loader = false;
            if (err.response && err.response.status == 401) {
              return;
            }
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          }
        });
    },
    getPermitCustomer() {
      if (this.permit_customer_source) {
        this.permit_customer_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.permit_customer_source = CancelToken.source();

      this.permit_customer_loader = true;
      this.axios
        .post(
          window.hostname + "api/auth/reports/permit-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            space_id: this.space_id,
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.permit_customer_source.token,
          }
        )
        .then((res) => {
          this.permit_customer_loader = false;
          this.permit_reload_btn      = 0;
          if (!res.data.status) {
            return;
          }
          let response = service.getCalculateData(
            res.data.data.current_permit_customer_count,
            res.data.data.past_permit_customer_count
          );
          this.session_reports.monthly_customer =
            res.data.data.current_permit_customer_count;
          this.session_reports.monthly_customer_inc_value = response.data_inc;
          this.session_reports.monthly_customer_inc = response.data_inc_status;
          // // console.log(response);
        })
        .catch((err) => {
          this.permit_reload_btn      = 0;

          if (this.axios.isCancel(err)) {
            // // console.log("Request canceled", err);
            this.permit_customer_loader = true;
          } else {
            // // console.log(err);
            this.permit_customer_loader = false;
          }
        });
    },
    getAnonymousCustomer() {
      if (this.anonymous_customer_source) {
        this.anonymous_customer_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.anonymous_customer_source = CancelToken.source();
      this.anonymous_customer_loader = true;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/anonymous-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            space_id: this.space_id,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.anonymous_customer_source.token,
          }
        )
        .then((res) => {
          this.anonymous_customer_loader = false;
          this.anonymous_reload_btn       = 0;
          if (!res.data.status) {
            return;
          }
          let response = service.getCalculateData(
            res.data.data.current_anonymous_customer_count,
            res.data.data.past_anonymous_customer_count
          );
          this.session_reports.anonymous_customer =
            res.data.data.current_anonymous_customer_count;
          this.session_reports.anonymous_customer_inc_value = response.data_inc;
          this.session_reports.anonymous_customer_inc =
            response.data_inc_status;

          // // console.log(response);
        })
        .catch((err) => {
          this.anonymous_reload_btn = 1;
          if (this.axios.isCancel(err)) {
            // // console.log("Request canceled", err);
            this.anonymous_customer_loader = true;
          } else {
            // // console.log(err);
            this.anonymous_customer_loader = false;
          }
        });
    },

    getAvgSessionReport() {
      if (this.avg_source) {
        this.avg_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.avg_source = CancelToken.source();

      this.avg_session_loader = true;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/avg-duration",
          {
            device_type: 1,
            commercial: 1,
            space_id: this.space_id,
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.avg_source.token,
          }
        )
        .then((res) => {
          if (!res.data.status) {
            return;
          }
          this.avgSessionDuration_reload_btn = 0;
          this.avg_session_loader = false;
          let response = service.getCalculateData(
            res.data.data.avg_session_duration_seconds,
            res.data.data.avg_session_duration_seconds_past
          );
          this.session_reports.avg_session_duration =
            res.data.data.avg_session_duration;
          this.session_reports.avg_session_duration_inc_value =
            response.data_inc;
          this.session_reports.avg_session_duration_inc =
            response.data_inc_status;
        })
        .catch((err) => {
          this.avgSessionDuration_reload_btn = 1;

          if (this.axios.isCancel(err)) {
            // // console.log("Request canceled", err);
            this.avg_session_loader = true;
          } else {
            this.avg_session_loader = false;
            if (err.response.status == 401) {
              return;
            }
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          }
        });
    },
    getAvgSessionPrice() {
      if (this.avg_price_source) {
        this.avg_price_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.avg_price_source = CancelToken.source();
      this.avg_session_price_loader = true;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/avg-price",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            space_id: this.space_id,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.avg_price_source.token,
          }
        )
        .then((res) => {
          this.avgSessionPrice_reload_btn   = 0;

          this.avg_session_price_loader = false;
          if (!res.data.status) {
            return;
          }
          let response = service.getCalculateData(
            res.data.data.avg_session_price,
            res.data.data.avg_session_price_past
          );
          this.session_reports.avg_session_price =
            res.data.data.avg_session_price.toFixed(2);
          this.session_reports.avg_session_price_inc_value = response.data_inc;
          this.session_reports.avg_session_price_inc = response.data_inc_status;
        })
        .catch((err) => {
          this.avgSessionPrice_reload_btn   = 1;

          if (this.axios.isCancel(err)) {
            this.avg_session_price_loader = true;
          } else {
            this.avg_session_price_loader = false;
          }
        });
    },
    //session chart report
    getSessionChartData(cust_type) {
      this.session_chart = [];
      this.session_earning_loader = true;
      this.session_earning_reload_btn = 1;
      if (this.session_earning_source) {
        this.session_earning_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_earning_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "api/auth/reports/sessions",
          {
            time_zone: this.$moment.tz.guess(new Date()),
            from: this.report_from,
            to: this.report_to,
            commercial: 1,
            report_type: this.report_type,
            space_id: this.space_id,
            customer_type: cust_type,
            permit_type: this.earning_permit_type_filter,
          },
          {
            cancelToken: this.session_earning_source.token,
          }
        )
        .then((res) => {
          this.session_earning_loader = false;
          this.session_earning_reload_btn = 0;
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_earning_chart_total = parseInt(res.data.data.total);
            if (
              this.session_chart_report_type == "hour" ||
              this.session_chart_report_type == "week"
            ) {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_earning_chart_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_earning_chart_percentage = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_earning_chart_percentage = "+100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total) -
                      parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total_prev) -
                      parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseInt(this.session_chart[length].y);
              let prev_value = parseInt(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_earning_chart_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_earning_chart_percentage = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_earning_chart_percentage = "+0.00";
                } else {
                  this.session_earning_chart_percentage =
                    ((last_value - prev_value) / prev_value).toFixed(2) * 100;
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((prev_value - last_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            }
          }
        })
        .catch((err) => {
          
          
          if (this.axios.isCancel(err)) {
            this.session_earning_reload_btn = 1;
            // // console.log("Request canceled", err.message);
            this.session_earning_loader = true;
          } else {
            this.session_earning_reload_btn = 2;
            this.session_earning_loader = false;
            if (err.response.status == 401) {
              return;
            }
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          }
        });
    },
    //earning chart report
    async getEarningChartData(cust_type) {
      this.session_chart = [];
      this.session_earning_reload_btn = 1;
      this.session_earning_loader = true;
      if (this.session_earning_source) {
        this.session_earning_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_earning_source = CancelToken.source();

      await this.axios
        .post(
          window.hostname + "api/auth/reports/earnings",
          {
            space_id: this.space_id,
            report_type: this.report_type,
            from: this.report_from,
            to: this.report_to,
            commercial: 1,
            time_zone: this.$moment.tz.guess(new Date()),
            customer_type: cust_type,
            permit_type: this.earning_permit_type_filter
          },
          {
            cancelToken: this.session_earning_source.token,
          }
        )
        .then((res) => {
          this.session_earning_reload_btn = 0;
          this.session_earning_loader = false;
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_earning_chart_total = parseFloat( res.data.data.total ).toFixed(2);
            if (
              this.session_chart_report_type == "hour" ||
              this.session_chart_report_type == "week"
            ) {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_earning_chart_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_earning_chart_percentage = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_earning_chart_percentage = "+100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total) -
                      parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total_prev) -
                      parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseFloat(this.session_chart[length].y);
              let prev_value = parseFloat(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_earning_chart_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_earning_chart_percentage = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_earning_chart_percentage = "+0.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((last_value - prev_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((prev_value - last_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            }
          }
        })
        .catch((err) => {
          
          if (this.axios.isCancel(err)) {
            this.session_earning_reload_btn = 1;
            // // console.log("Request canceled", err.message);
            this.session_earning_loader = true;
          } else {
            this.session_earning_reload_btn = 2;

            this.session_earning_loader = false;
            if (err.response.status == 401) {
              return;
            }
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          }
        });
    },
    // current occupancy chart report
    getOccupancyChartData(cust_type, permit_type = 1) {
      this.permit_type_filter = permit_type;
      // this.occupancy_type =1
      this.occupancy_type = 2;
      this.occupancy_chart = [];
      this.occupancy_current = 0;
      this.occupancy_loader = true;
      this.occupancy_customer_type = cust_type;
      if (this.occupancy_source) {
        this.occupancy_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.occupancy_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "api/auth/reports/occupancy",
          {
            space_id: this.space_id,
            report_type: this.report_type,
            from: this.report_from,
            to: this.report_to,
            commercial: 1,
            time_zone: this.$moment.tz.guess(new Date()),
            customer_type: cust_type,
            permit_type: this.permit_type_filter,
          },
          {
            cancelToken: this.occupancy_source.token,
          }
        )
        .then((res) => {
          this.occupancy_loader = false;
          this.occupancy_reload_btn   = 0;
          if (res.data.status) {
            this.occupancy_chart = res.data.data.report_data;
            if (this.report_type == "hour") {
              this.occupancy_current =
                this.occupancy_chart[this.occupancy_chart.length - 1].y;
            } else {
              let len = this.occupancy_chart.length;
              for (var i = 0; i < len; i++) {
                if (this.occupancy_chart[i].y > this.occupancy_current) {
                  this.occupancy_current = this.occupancy_chart[i].y;
                }
              }
            }
            // this.occupancy_total = res.data.data.total.toFixed(0);
            if (
              parseFloat(res.data.data.total) >
              parseFloat(res.data.data.total_prev)
            ) {
              this.occupancy_inc = true;
              let diff_data =
                parseFloat(res.data.data.total) -
                parseFloat(res.data.data.total_prev);
              let perc = (diff_data / parseFloat(res.data.data.total)) * 100;
              perc = perc.toFixed(2);
              perc = perc > 100 ? 100 : perc;
              this.occupancy_inc_percentage = "+" + perc;
            } else if (
              parseFloat(res.data.data.total) <
              parseFloat(res.data.data.total_prev)
            ) {
              this.occupancy_inc = false;
              let diff_data =
                parseFloat(res.data.data.total_prev) -
                parseFloat(res.data.data.total);
              let perc =
                (diff_data / parseFloat(res.data.data.total_prev)) * 100;
              perc = perc.toFixed(2);
              perc = perc > 100 ? 100 : perc;
              this.occupancy_inc_percentage = "-" + perc;
            } else {
              this.occupancy_inc = true;
              this.occupancy_inc_percentage = "+0.00";
            }
          }
        })
        .catch((err) => {
          this.occupancy_reload_btn   = 1;

          if (this.axios.isCancel(err)) {
            this.occupancy_loader = true;
          } else {
            this.occupancy_loader = false;
            if (err.response.status == 401) {
              return;
            }
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          }
        });
    },
    openActivitySession(activity) {
      if (activity.target == "bookings") {
        this.axios
          .post(window.hostname + "/api/auth/booking", {
            booking_id: activity.target_id,
            space_id: this.space_id,
            mode: "show-booking",
            time_zone: this.$moment.tz.guess(new Date()),
            booking_for: "owner",
            administrator:this.administrator
          })
          .then((res) => {
            if (res.data.status) {
              this.$modal.show("session-details", {
                timezone: this.timezone,
                data: res.data.data.booking_details,
                session_type:
                  res.data.data.booking_details.booking_end_date != "" ? 2 : 1,
                property_timezone: this.property_timezone,
              });
            } else {
              return;
            }
          })
          .catch((err) => {
            return;
          });
      }
    },
    //=================== ACTIVATE OR INACTIVATE PROPERTY ==============//
    changePropertyStatus() {
      const self = this;
      let m = this.space_details.active
        ? `Do you want to disable this property?`
        : `Do you want to enable this property?`;
      this.$swal({
        title: "Are you sure?",
        text: m,
        showCancelButton: true,
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        } else {
          self.axios
            .post(window.hostname + "/api/auth/inactive-space", {
              property_id: this.space_id,
            })
            .then((res) => {
              if (res.data.status) {
                self.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                self.getPropertyDetails();
              } else {
                self.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
            })
            .catch((err) => {
              self.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
    //==================== Delete Property =========================//
    deleteProperty() {
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete this property?",
        showCancelButton: true,
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }
        self.axios
          .post(window.hostname + "/api/auth/delete-space", {
            property_id: self.space_id,
          })
          .then((res) => {
            if (res.data.status) {
              self.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              self.$nextTick(() => {
                self.$router.push("/dashboard");
              });
            } else {
              self.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            self.$toasted.show(err.response.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          });
      });
    },
    checkRealCount(){
      this.occupancy_loader = true;
      // // console.log("hii");
      this.occupancy_type =2;
      this.axios
        .post(window.hostname + "api/auth/all-space", {
          limit: 500,
          device_type: 1,
          space_id: this.space_id,
          status: 0,
          page: 1,
          minify: 1,
          minify_2: 0,
          time_zone: this.$moment.tz.guess(new Date()),
        }).then((res)=>{
          // console.log(res);
          this.occupancy_loader = false;
          this.occupancy_total=res.data.data.occupancy_percentage;
          // console.log(this.occupancy_total);

        })
    }
  },
};
</script>

<style>
.slick-slider {
  padding-left: 5px;
  padding-right: 5px;
}
.slick-list {
  padding: 0 35px !important;
}

.modal-backdrop.show {
  opacity: 0.8;
}
#session_div {
  scroll-behavior: smooth;
}
#modal_session_div {
  scroll-behavior: smooth;
}
.sessions_number_box_vin {
  background-color: var(--primaryWhite);
  border-radius: 3px;
  padding: 10px 5px;
  cursor: pointer;
  color: var(--primaryColor);
  flex-shrink: 0;
  width: 75px;
}
.sessions_number_box_vin .images_state img {
  position: absolute;
  top: -7px;
  right: -5px;
}
.sessions_number_box_long {
  background-color: var(--primaryWhite);
  border-radius: 3px;
  padding: 6px 8px;
  cursor: pointer;
  /* width: 125px; */
  color: black;
  cursor: default;
}
.cursor_class {
  cursor: default !important ;
}
.monthly-filter-select {
  width: 120px;
}
</style>
